import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNecComponent } from './simple-icons-nec.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNecComponent ],
    exports:      [ SimpleIconsNecComponent ],
    bootstrap:    []
})
export class SimpleIconsNecModule {}
